import React from "react"

const KWHotelPage = () => {
  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&family=Montserrat:wght@400;700&display=swap"
        rel="stylesheet"
      />
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
        rel="stylesheet"
      />

      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: 'Open Sans', sans-serif; color: #333; background: #fbfbfb; }

        .top-bar {
            background: #1a1a2e;
            color: #ccc;
            padding: 8px 0;
            font-size: 13px;
        }
        .top-bar a { color: #fff; text-decoration: none; font-weight: 600; }

        .site-header {
            background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
            padding: 15px 0;
        }
        .site-header .logo-text {
            color: #fff;
            font-family: 'Montserrat', sans-serif;
            font-weight: 700;
            font-size: 24px;
            text-decoration: none;
        }
        .site-header .nav-link {
            color: rgba(255,255,255,0.8);
            font-family: 'Montserrat', sans-serif;
            font-weight: 600;
            font-size: 13px;
            letter-spacing: 1px;
            text-transform: uppercase;
            padding: 8px 16px !important;
            transition: color 0.2s;
        }
        .site-header .nav-link:hover { color: #fff; }

        .hero {
            position: relative;
            min-height: 300px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            color: #fff;
            overflow: hidden;
        }
        .hero-bg {
            position: absolute;
            inset: 0;
            background: url('https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1600&q=80') center/cover no-repeat;
            z-index: 0;
        }
        .hero-overlay {
            position: absolute;
            inset: 0;
            background: linear-gradient(to right, rgba(22,62,102,0.4) 0%, rgba(45,49,141,0.7) 100%);
            z-index: 1;
        }
        .hero-content {
            position: relative;
            z-index: 2;
            padding: 60px 20px;
        }
        .hero h1 {
            font-family: 'Montserrat', sans-serif;
            font-weight: 700;
            font-size: 48px;
            letter-spacing: 4px;
            margin-bottom: 10px;
        }
        .hero h2 {
            font-family: 'Open Sans', sans-serif;
            font-weight: 300;
            font-size: 20px;
            opacity: 0.9;
        }

        .booking-section { padding: 60px 0 80px; }
        .booking-iframe-container {
            width: 100%;
            max-width: 1200px;
            margin: 0 auto;
        }
        .booking-iframe-container iframe {
            width: 100%;
            height: 1200px;
            border: none;
            border-radius: 8px;
            box-shadow: 0 4px 24px rgba(0,0,0,0.12);
        }

        .site-footer {
            background: #1a1a2e;
            color: rgba(255,255,255,0.6);
            padding: 30px 0;
            font-size: 14px;
        }
        .site-footer a {
            color: rgba(255,255,255,0.6);
            text-decoration: none;
            margin-left: 20px;
            transition: color 0.2s;
        }
        .site-footer a:hover { color: #fff; }

        @media (max-width: 767px) {
            .hero h1 { font-size: 32px; letter-spacing: 2px; }
            .hero h2 { font-size: 16px; }
            .hero-content { padding: 40px 15px; }
            .booking-iframe-container iframe { height: 900px; }
            .booking-section { padding: 30px 0 50px; }
        }
      `}</style>

      <div className="top-bar">
        <div className="container d-flex justify-content-between align-items-center">
          <div>
            <span>PYTANIA? ZADZWON: </span>
            <a href="tel:+48123456789">+48 123 456 789</a>
          </div>
        </div>
      </div>

      <nav className="site-header">
        <div className="container d-flex justify-content-between align-items-center">
          <a href="/kwhotel/" className="logo-text">KWHOTEL</a>
          <div className="d-none d-md-flex">
            <a href="#" className="nav-link">STRONA GLOWNA</a>
            <a href="#" className="nav-link">OFERTA</a>
            <a href="#" className="nav-link">O NAS</a>
            <a href="#" className="nav-link">KONTAKT</a>
          </div>
        </div>
      </nav>

      <section className="hero">
        <div className="hero-bg"></div>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>KWHOTEL</h1>
          <h2>Zarezerwuj pokoj online</h2>
        </div>
      </section>

      <section className="booking-section">
        <div className="container">
          <div className="booking-iframe-container">
            <iframe
              src="https://be-dev.guestsage.com/pl/82b0085d-da1b-4443-8fde-d5d569a859e6/offers?arrivalDate=2026-04-01&departureDate=2026-04-02&personsCount=2&ageCategoryCounts=[]&addOns=[]&referral=be-dev.guestsage.com&hostelView=true"
              title="KWHotel - Rezerwacja online"
              allow="payment"
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </section>

      <footer className="site-footer">
        <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div>&copy; 2026 KWHotel. All rights reserved.</div>
          <div className="mt-2 mt-md-0">
            <a href="#">REGULAMIN</a>
            <a href="#">POLITYKA PRYWATNOSCI</a>
            <a href="#">KONTAKT</a>
          </div>
        </div>
      </footer>

      <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js"></script>
    </>
  )
}

export default KWHotelPage

export const Head = () => (
  <>
    <html lang="pl" dir="ltr" />
    <meta charSet="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <meta name="robots" content="noindex, nofollow" />
    <meta name="keywords" content="kwhotel, rezerwacja pokoju, hotel, booking" />
    <meta name="description" content="KWHotel - Rezerwacja pokoju hotelowego online" />
    <title>KWHotel - Rezerwacja online</title>
    <script>{`window.aichatbotApiKey="b2a7e419-d4e6-44c3-b7d3-581f1fbda320"; window.aichatbotProviderId="f9e9c5e4-6d1a-4b8c-8d3f-3f9e9c5e46d1";`}</script>
    <script src="https://script.chatlab.com/aichatbot.js" id="b2a7e419-d4e6-44c3-b7d3-581f1fbda320" defer />
  </>
)
